import { useState } from "react";
import { Table } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import { RiAlertFill } from 'react-icons/ri';
import CurrencyInput from 'react-currency-input-field';
import { IColumnTableProps } from "../../../Interfaces/IColumnTableProps";

interface ItableProps {
    columns: IColumnTableProps[],
    rows: any[],
    hasHeader?: boolean,
    totalData?: number,
    page?: number,
    isTableInverted?: boolean,
    isEditable?: boolean,
    containsIconsWithValidation?: boolean,
    lastRowIsEditable?: boolean,
    functionToEdit?: (idLine: string, value: string, idColumn: string) => Promise<void>,
    canNotEdit?: boolean
}

const CustomTableComponent = (props: ItableProps) => {
    const [valueHelper, setValueHelper] = useState("");

    const verifyConditions = (value: any, id: string) => {
        var objectValidate = {
            isAccept: false,
            title: ""
        };

        switch (id) {
            case "financingByInvoicing":
                objectValidate.isAccept = value <= 15;
                objectValidate.title = value <= 15 ? "Sem impedimentos" : "O Financiamento está superando o faturamento de um ano de empresa, dificilmente será aceito, reduzir o valor do financiamento para que a proporção seja menor que 15%";
                break;
            case "shortDebtByAvailability":
                objectValidate.isAccept = value <= 100;
                objectValidate.title = value <= 100 ? "Sem impedimentos" : "O Endividamento de curto prazo da empresa está elevado, representando mais de 100% do valor que a empresa tem disponivel, o risco de análise financeira é alto para esse projeto";
                break;
            case "totalIndebtednessByAvailability":
                objectValidate.isAccept = value <= 120;
                objectValidate.title = value <= 120 ? "Sem impedimentos" : value > 135 ? "Risco elevado" : "O Endividamento a longo prazo da empresa está elevado, representando mais de 120% do valor que a empresa tem disponivel, o risco de análise financeira é médio para esse projeto";
                break;
            case "totalIndebtednessFinancingByAvailability":
                objectValidate.isAccept = value <= 135;
                objectValidate.title = value <= 135 ? "Sem impedimentos" : "Verificar o orçamento do projeto, e se possivel reduzir para diminuir o risco";
                break;
            case "proportionFinancingPL":
                objectValidate.isAccept = value > 0 && value <= 35;
                objectValidate.title = value > 0 && value <= 35 ? "Sem impedimentos" : value < 0 ? "Cuidado, a empresa está com o Passivo a descoberto, assim o risco de crédito é muito alto" : "O Financiamento está superando o valor do PL da empresa, reduzir o valor do financiamento";
                break;
            case "proportionFinancing":
                objectValidate.isAccept = value <= 10;
                objectValidate.title = value <= 10 ? "Sem impedimentos" : "O Financiamento está superando o limite permitido do valor do Ativo, reduzir o valor do financiamento";
                break;
            case "plAssets":
                objectValidate.isAccept = value > 30;
                objectValidate.title = value > 30 ? "Sem impedimentos" : "O PL está muito baixo em relação ao Ativo, risco de crédito no BNDES aumenta";
                break;
            default:
                break;
        }

        return objectValidate;
    }

    return (
        <Table striped bordered hover className='back-white'>
            {props.hasHeader &&
                <thead>
                    <tr>
                        {props.isTableInverted &&
                            <>
                                <th>{props.columns[0].name}</th>
                                {props.rows.map((row, index) => {
                                    return (
                                        <th key={index}>{row[props.columns[0].id]}</th>
                                    )
                                })}
                            </>
                        }

                        {!props.isTableInverted &&
                            props.columns?.map((column, index) => {
                                return (
                                    <th key={index}>{column.name}</th>
                                )
                            })
                        }
                    </tr>
                </thead>
            }
            <tbody>
                {props.isTableInverted && props.columns.map((column, index) => {
                    if (index === 0 && props.hasHeader) return;
                    return (
                        <tr key={index}>
                            <th>{column.name}</th>
                            {props.isEditable && props.rows.map((row, i) => {
                                return (
                                    <th key={i}>
                                        {(!props.lastRowIsEditable && index == props.columns.length - 1) &&
                                            <span className='ms-1 text-result'>
                                                R$ {new Intl.NumberFormat("pt-BR", {
                                                    minimumFractionDigits: 2,
                                                }).format(row[column.id])}
                                            </span>
                                        }
                                        {((!props.lastRowIsEditable && index != props.columns.length - 1) || props.lastRowIsEditable) &&
                                            <CurrencyInput
                                                id="input-example"
                                                name="input-name"
                                                className='form-control'
                                                intlConfig={{ locale: 'pt-BR' }}
                                                placeholder="0,00"
                                                onBlur={() => { props.functionToEdit?.(column.id, valueHelper, row.id); setValueHelper("") }}
                                                defaultValue={row[column.id]}
                                                disabled={props.canNotEdit}
                                                decimalsLimit={2}
                                                onValueChange={(value: any, name: any) => setValueHelper(value)}
                                            />
                                        }
                                    </th>
                                )
                            })}
                            {!props.isEditable && props.rows.map((row, i) => {
                                return (
                                    <th key={i} className='columns-adjusts'>
                                        {!isNaN(row[column.id]) ?
                                            <span className='ms-1 text-result'>
                                                R$ {new Intl.NumberFormat("pt-BR", {
                                                    minimumFractionDigits: 2,
                                                }).format(row[column.id])}
                                            </span>
                                            : row[column.id]?.includes("R$") ?
                                                "R$ " + new Intl.NumberFormat("pt-BR", {
                                                    minimumFractionDigits: 2,
                                                }).format(row[column.id].replace("R$ ", "").replace(",", "."))
                                                :
                                                row[column.id]
                                        }
                                    </th>
                                )
                            })}
                            {props.containsIconsWithValidation && props.rows.map((row, i) => {
                                var val = row[column.id].substring(0, row[column.id].length - 1).replaceAll(".", "").replace(",", ".");
                                var row2 = verifyConditions(parseFloat(val), column.id);
                                return (
                                    <th key={i}>
                                        <div title={row2.title} className="d-flex align-items-center justify-content-center w-100 h-100">
                                            {row2.isAccept ?
                                                <FaCheckCircle size={20} className='color-check' />
                                                :
                                                <RiAlertFill size={20} className='color-alert' />
                                            }
                                        </div>
                                    </th>
                                )
                            })}
                        </tr>
                    )
                })}

                {!props.isTableInverted && props.rows.map((row, index) => {
                    return (
                        <tr key={index}>
                            {props.isEditable && props.columns?.map((column, i) => {
                                return (
                                    <th key={i}>
                                        {(!props.lastRowIsEditable && index == props.rows.length - 1) &&
                                            <span className='ms-3 text-result'>{row[column.id].toFixed(2)}</span>
                                        }
                                        {((!props.lastRowIsEditable && index != props.rows.length - 1) || props.lastRowIsEditable) &&
                                            <CurrencyInput
                                                id="input-example"
                                                name="input-name"
                                                className='form-control'
                                                intlConfig={{ locale: 'pt-BR' }}
                                                placeholder="0,00"
                                                onBlur={() => { props.functionToEdit?.(row.id, valueHelper, column.id); setValueHelper("") }}
                                                defaultValue={row[column.id]}
                                                disabled={props.canNotEdit}
                                                decimalsLimit={2}
                                                onValueChange={(value: any, name: any) => setValueHelper(value)}
                                            />
                                        }
                                    </th>
                                )
                            })}

                            {!props.isEditable && props.columns?.map((column, index) => {
                                return (
                                    <th key={index}>{row[column.id]}</th>
                                )
                            })}
                        </tr>
                    )
                })}
            </tbody>
        </Table>
    )
}

export default CustomTableComponent;